import { render, staticRenderFns } from "./Gallery7.vue?vue&type=template&id=e645dd4e&scoped=true&"
import script from "./Gallery7.vue?vue&type=script&lang=js&"
export * from "./Gallery7.vue?vue&type=script&lang=js&"
import style0 from "./Gallery7.vue?vue&type=style&index=0&id=e645dd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e645dd4e",
  null
  
)

export default component.exports